<ui-modal
  class="csa-modal"
  [isOpened]="showcsa"
  modalTitle="CSA"
  (isOpenedChange)="modalChanged($event)"
>
  <div class="csa">
    <form [formGroup]="csaForm" (ngSubmit)="saveChanges()">
      <div class="csa__table-info-group-container">
        <div class="csa__table-info">
          <div #divToScroll class="table-container scrollable-content">
            <table ui-table>
              <thead>
                <tr>
                  <th class="counter-party-A">CounterParty A</th>
                  <th class="counter-party-B">CounterParty B</th>
                  <th class="counter-party-A-posts">CounterParty A posts</th>
                  <th class="counter-party-B-posts">CounterParty B posts</th>
                  <th class="currency">Currency</th>

                  <th class="counter-party-A-posts-threshold">
                    CounterParty A threshold
                  </th>
                  <th class="counter-party-B-posts-threshold">
                    CounterParty B threshold
                  </th>

                  <th class="counter-party-A-independent-amount">
                    CounterParty A independent amount
                  </th>
                  <th class="counter-party-B-independent-amount">
                    CounterParty B independent amount
                  </th>

                  <th class="counter-party-A-posted-variation-margin">
                    CounterParty A posted variation margin
                  </th>

                  <th class="counter-party-B-posted-variation-margin">
                    CounterParty B posted variation margin
                  </th>
                  <th class="mta">MTA</th>
                </tr>
              </thead>
              <tbody>
                <ng-container formArrayName="csaArray">
                  <tr
                    tabindex="0"
                    *ngFor="let item of csaArray.controls; let i = index"
                    (click)="selectedCsaIndex = i"
                    [ngClass]="{ 'selected-row': selectedCsaIndex === i }"
                  >
                    <ng-container [formGroupName]="i">
                      <td>
                        <select
                          formControlName="counterPartyA"
                          [ngClass]="{
                            placeholder: item.get('counterPartyA')?.value === ''
                          }"
                        >
                          <option value="" disabled selected hidden>
                            CSA #{{ i + 1 }}
                          </option>
                          <option
                            *ngFor="let item of identifiers"
                            [value]="item"
                          >
                            {{ item }}
                          </option>
                        </select>
                      </td>

                      <td>
                        <select formControlName="counterPartyB">
                          <option
                            *ngFor="let item of identifiers"
                            [value]="item"
                          >
                            {{ item }}
                          </option>
                        </select>
                      </td>

                      <td>
                        <select formControlName="counterPartyA:posts">
                          <option value="True">True</option>
                          <option value="False">False</option>
                        </select>
                      </td>

                      <td>
                        <select formControlName="counterPartyB:posts">
                          <option value="True">True</option>
                          <option value="False">False</option>
                        </select>
                      </td>

                      <td>
                        <select formControlName="currency">
                          <option
                            [value]="currency"
                            *ngFor="let currency of csaCurrencies"
                          >
                            {{ currency }}
                          </option>
                        </select>
                      </td>

                      <td>
                        <input
                          [inputValidator]="['numericShorthand']"
                          name=""
                          class="input-cell"
                          formControlName="counterPartyA:threshold"
                          (click)="
                            amountTextBoxRestrictionHandler($event, 'click')
                          "
                          (keydown)="
                            amountTextBoxRestrictionHandler($event, 'keydown')
                          "
                          (input)="
                            textBoxAdderPrep(
                              item.get('counterPartyA:threshold'),
                              item.get('currency').value,
                              'currency',
                              $any($event.target)
                            )
                          "
                        />
                      </td>

                      <td>
                        <input
                          [inputValidator]="['numericShorthand']"
                          name=""
                          class="input-cell"
                          formControlName="counterPartyB:threshold"
                          (click)="
                            amountTextBoxRestrictionHandler($event, 'click')
                          "
                          (keydown)="
                            amountTextBoxRestrictionHandler($event, 'keydown')
                          "
                          (input)="
                            textBoxAdderPrep(
                              item.get('counterPartyB:threshold'),
                              item.get('currency').value,
                              'currency',
                              $any($event.target)
                            )
                          "
                        />
                      </td>

                      <td>
                        <input
                          [inputValidator]="['numericShorthand']"
                          name=""
                          class="input-cell"
                          formControlName="counterPartyA:independentAmount"
                          (click)="
                            amountTextBoxRestrictionHandler($event, 'click')
                          "
                          (keydown)="
                            amountTextBoxRestrictionHandler($event, 'keydown')
                          "
                          (input)="
                            textBoxAdderPrep(
                              item.get('counterPartyA:independentAmount'),
                              item.get('currency').value,
                              'currency',
                              $any($event.target)
                            )
                          "
                        />
                      </td>

                      <td>
                        <input
                          [inputValidator]="['numericShorthand']"
                          name=""
                          class="input-cell"
                          formControlName="counterPartyB:independentAmount"
                          (click)="
                            amountTextBoxRestrictionHandler($event, 'click')
                          "
                          (keydown)="
                            amountTextBoxRestrictionHandler($event, 'keydown')
                          "
                          (input)="
                            textBoxAdderPrep(
                              item.get('counterPartyB:independentAmount'),
                              item.get('currency').value,
                              'currency',
                              $any($event.target)
                            )
                          "
                        />
                      </td>

                      <td>
                        <input
                          [inputValidator]="['numericShorthand']"
                          name=""
                          class="input-cell"
                          formControlName="counterPartyA:postedVariationMargin"
                          (click)="
                            amountTextBoxRestrictionHandler($event, 'click')
                          "
                          (keydown)="
                            amountTextBoxRestrictionHandler($event, 'keydown')
                          "
                          (input)="
                            textBoxAdderPrep(
                              item.get('counterPartyA:postedVariationMargin'),
                              item.get('currency').value,
                              'currency',
                              $any($event.target)
                            )
                          "
                        />
                      </td>

                      <td>
                        <input
                          [inputValidator]="['numericShorthand']"
                          name=""
                          class="input-cell"
                          formControlName="counterPartyB:postedVariationMargin"
                          (click)="
                            amountTextBoxRestrictionHandler($event, 'click')
                          "
                          (keydown)="
                            amountTextBoxRestrictionHandler($event, 'keydown')
                          "
                          (input)="
                            textBoxAdderPrep(
                              item.get('counterPartyB:postedVariationMargin'),
                              item.get('currency').value,
                              'currency',
                              $any($event.target)
                            )
                          "
                        />
                      </td>

                      <td>
                        <input
                          [inputValidator]="['numericShorthand']"
                          name=""
                          class="input-cell"
                          formControlName="mta"
                          (click)="
                            amountTextBoxRestrictionHandler($event, 'click')
                          "
                          (keydown)="
                            amountTextBoxRestrictionHandler($event, 'keydown')
                          "
                          (input)="
                            textBoxAdderPrep(
                              item.get('mta'),
                              item.get('currency').value,
                              'currency',
                              $any($event.target)
                            )
                          "
                        />
                      </td>
                    </ng-container>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
          <div class="bottom-table-add">
            <div *ngIf="!loadingData; else EntitiesLoading">
              <span class="add-text-container"
                ><label class="Page-1">+</label>
                <label class="add-text" (click)="addNewCsa()"
                  >Add CSA</label
                ></span
              >
            </div>
            <ng-template #EntitiesLoading>
              <span class="add-text-container">
                <label class="add-text add-text--loading">Loading</label></span
              >
            </ng-template>
          </div>
        </div>
        <div class="csa__table-info__container__footer">
          <button
            class="ui-button ui-button__header ui-button--danger ui-button--delete"
            [disabled]="selectedCsaIndex === null"
            (click)="deleteCsa()"
          >
            Delete
          </button>
        </div>
      </div>

      <div class="csa__footer">
        <button
          type="submit"
          class="ui-button primary"
          [disabled]="!allowedToSave"
        >
          <ng-container [ngSwitch]="savingCsaStatus">
            <span *ngSwitchCase="''"> Save </span>
            <span
              *ngSwitchCase="'LOADING'"
              class="spinner spinner-sm spinner-inverse"
            >
            </span>
            <span *ngSwitchCase="'DONE'"> Saved </span>
            <span *ngSwitchCase="'ERROR'"> Error </span>
          </ng-container>
        </button>
        @if (reasonCantSave === 'SAME_COUNTERPARTIES') {
          Counterparties must be different.
        }
        @if (reasonCantSave === 'MISSING_INTERNAL_ENTITY') {
          Each CSA must contain at least one internal entity.
        }
      </div>
    </form>
  </div>
</ui-modal>
